import { Banner } from '@astryxdesign/core/Banner';
import type { PublicTenant } from './schemas';

/** Honest marker: preview studios show demo data and send no real notifications. */
export function PreviewBanner({ tenant }: { tenant: PublicTenant }) {
  if (tenant.status === 'live') return null;
  return (
    <Banner
      status="warning"
      title={tenant.is_demo ? 'Демо-студия' : 'Студия готовится к запуску'}
      description={tenant.is_demo ? 'Все записи здесь демонстрационные, уведомления не отправляются.' : 'Онлайн-запись работает в тестовом режиме: уведомления пока не отправляются.'}
    />
  );
}
